import styled from "@emotion/styled";
import { ReviewableType } from "features/reviewable";

type ImageProps = {
  aspectRatio?: React.CSSProperties["aspectRatio"];
  entityType?: ReviewableType;
};

const Img = styled.img<ImageProps>(({ aspectRatio, entityType, theme }) => ({
  aspectRatio,
  display: "block",
  objectFit: "cover",
  width: "100%",
  maxWidth: "100%",
  position: "relative",
  ...(entityType && {
    borderRadius:
      entityType === "ARTIST"
        ? theme.borderRadius.round
        : theme.borderRadius.xs,
  }),
}));

export { Img };
